import React, { useCallback } from 'react';
import { Box, Stack, Divider, Chip } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';

const invTyps = [
  { id: 1, value: '매출', label: '수금', color: 'primary' },
  { id: 2, value: '매입', label: '지급', color: 'secondary' },
];

// const useYns = [
//   { id: 0, value: '', label: '전체', color: 'warning' },
//   { id: 1, value: 'Y', label: '완료', color: 'success' },
//   { id: 2, value: 'N', label: '미완료', color: 'error' },
// ];

const CollectBuyStatusList = ({ filters, onFilters }) => {
  const handleFilterBillType = useCallback(
    (value) => {
      onFilters('searchInvTyp', value);
    },
    [onFilters],
  );

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItem: 'center',
        m: 1,
      }}
    >
      <Stack
        direction="row"
        divider={<Divider orientation="vertical" flexItem />}
        spacing={2}
      >
        <Box sx={{ mx: 1 }}>
          {invTyps &&
            invTyps.map((st, index) => (
              <Chip
                sx={{ mr: 2 }}
                key={index}
                icon={<CircleIcon />}
                label={st.label}
                variant={
                  st.value === filters?.searchInvTyp ? 'contained' : 'outlined'
                }
                color={st.color}
                onClick={() => handleFilterBillType(st.value)}
              />
            ))}
        </Box>
      </Stack>
    </Box>
  );
};

export default CollectBuyStatusList;
